module.exports = __webpack_public_path__ + "img/churrasco.ec741cbb.svg";